import React from 'react';


function Footer() {
  return (
    <footer className="footer">
      
      <div className="logo-container">
      </div>
      <p className="footer-links">
        <a href="/station">Weather Satellite Station</a>
      </p>
      
      <p className="all-rights-reserved">&copy; 2026 DJFracking. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
